import { GRAPHQL } from 'const';
import { intercept } from 'debugger';
import {
  Environment,
  Network,
  RecordSource,
  Store,
  RequestParameters,
  CacheConfig,
  UploadableMap,
} from 'relay-runtime';

async function fetchRelay(
  params: RequestParameters,
  variables: any,
  cacheConfig: CacheConfig,
  uploadables?: UploadableMap | null
) {
  const headers: HeadersInit = new Headers();

  const token =
    localStorage.getItem('token') ?? sessionStorage.getItem('token');

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  if (!GRAPHQL) {
    throw new Error(
      'Graphql URL not defined. Make sure you have REACT_APP_GRAPHQL variable set in your environment'
    );
  }

  const request: RequestInit = {
    method: 'POST',
  };

  const operation = JSON.stringify({
    query: params.text,
    variables,
  });

  if (uploadables) {
    const formData = new FormData();

    formData.append('operations', operation);

    type UploadableMap = {
      [key: string]: string[];
    };

    const map: UploadableMap = {};

    Object.keys(uploadables).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(uploadables, key)) {
        map[key] = [`variables.${key}`];
      }
    });

    formData.append('map', JSON.stringify(map));

    for (const uploadable in uploadables) {
      if (Object.prototype.hasOwnProperty.call(uploadables, uploadable)) {
        formData.append(uploadable, uploadables[uploadable]);
      }
    }

    request.body = formData;
    request.headers = headers;
  } else {
    headers.set('Content-Type', 'application/json');

    request.headers = headers;
    request.body = operation;
  }

  return fetch(GRAPHQL, request).then(response =>
    response.json().then(response => {
      intercept({ request, response });

      return response;
    })
  );
}

export const environment = new Environment({
  network: Network.create(fetchRelay),
  store: new Store(new RecordSource()),
});
